export function SET_FILTERS({ commit }, [search, selected_areas, selected_tags]) {
    commit('SAVE_FILTERS', [search, selected_areas, selected_tags])
}